import { IoSchool } from "react-icons/io5";
import { useGlobalContext } from "./context/globalContext";
import React, { useState, useRef, useEffect } from "react";
import { MdHealthAndSafety } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { FaMapLocation } from "react-icons/fa6";

const LocationBenefits2 = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  const [activeDetail, setActiveDetail] = useState(null);
  const detailsRef = useRef(null);

  // Handle click outside to close details
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the details and the icon
      if (
        detailsRef.current &&
        !detailsRef.current.contains(event.target) &&
        !event.target.closest(".benefit-icon")
      ) {
        setActiveDetail(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle icon click
  const handleIconClick = (index, event) => {
    event.stopPropagation();
    setActiveDetail(activeDetail === index ? null : index);
  };
  const benefits = [
    {
      icon: <IoSchool />,
      title: "Educational Institutes",
      details: ["Ryan International School", "St. Xavier's High School"],
    },
    {
      icon: <MdHealthAndSafety />,
      title: "Hospitals",
      details: ["Pooja Maternity & Nursing Home", "Shree Krishna Hospital"],
    },
    {
      icon: <FaShoppingCart />,
      title: "Malls & Entertainment",
      details: [
        "Raghuleela Mall",
        "Infinity Mall",
        "PVR Cinemas",
        "The Art Mall",
      ],
    },
    {
      icon: <FaMapLocation />,
      title: "Connectivity",
      details: [
        "Bhayandar Railway Station",
        "Western Express Highway",
        "Mira-Bhayandar Metro Line",
      ],
    },
  ];
  return (
    <>
      <div className="section shadow-sm lazyloaded">
        <div className="lb-container">
          <div className="lb-map">
            <img src="/images/lb.PNG" alt="Location Overview" />
          </div>
          <div className="lb-content">
            <div className="lb-content-body">
              <h2 className="head text-capitalize text-center">
                {project} - Location & Connectivity
              </h2>
              <div className="cards">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    className={`crd position-${index + 1}  ${
                      activeDetail === index ? "alive-card" : ""
                    } `}
                  >
                    <div
                      className="crd-icon"
                      onClick={(e) => handleIconClick(index, e)}
                    >
                      {benefit.icon}
                      <span className="crd-title">{benefit.title}</span>
                    </div>
                    <div
                      ref={activeDetail === index ? detailsRef : null}
                      className={`crd-details ${
                        activeDetail === index ? "active" : ""
                      }`}
                      id="card-details-scroll"
                    >
                      <ul>
                        {/* {benefit.details.map((detail, idx) => (
                          <li key={idx}>{detail}</li>
                        ))} */}
                        {benefit.details.map((detail, idx) => {
                          const parts = detail.split(" - "); // Using " - " (en dash) for separation
                          if (parts.length === 2) {
                            return (
                              <li key={idx}>
                                <span>{parts[0]}</span>

                                <span>{parts[1]}</span>
                              </li>
                            );
                          } else {
                            return <li key={idx}>{detail}</li>; // Handle cases with no " - "
                          }
                        })}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lb-content-footer">
              <span
                className="new-button "
                onClick={() => handleShowModal("Location Benefits")}
              >
                <span className="new-button-inner">
                  <span className="underline-animation">Get All Details</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocationBenefits2;
